var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.template.type === "GROUP"
    ? _c("questionnaire-form-section-group", {
        attrs: {
          globals: _vm.globals,
          model: _vm.model,
          response: _vm.response,
          template: _vm.template,
        },
        on: { change: _vm.$rbEmit, mounted: _vm.onSectionMounted },
      })
    : _vm.template.type === "TABLE"
    ? _c("questionnaire-form-section-table", {
        attrs: {
          config: _vm.config,
          globals: _vm.globals,
          model: _vm.model,
          response: _vm.response,
          template: _vm.template,
        },
        on: {
          change: _vm.$rbEmit,
          stateChange: _vm.$rbEmit,
          mounted: _vm.onSectionMounted,
        },
      })
    : _vm.template.type === "HOTEL_RFP_RATE_GRID"
    ? _c("questionnaire-form-hotel-rfp-rate-grid", {
        attrs: {
          config: _vm.config,
          globals: _vm.globals,
          model: _vm.model,
          response: _vm.response,
          template: _vm.template,
        },
        on: {
          change: _vm.$rbEmit,
          stateChange: _vm.$rbEmit,
          mounted: _vm.onSectionMounted,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }